// extracted by mini-css-extract-plugin
export var form = "_5f-0";